/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Account<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags accounts
   * @name DeleteAccount
   * @summary 退会
   * @request DELETE:/account
   */
  deleteAccount = (params: RequestParams = {}) =>
    this.request<any, void>({
      path: `/account`,
      method: "DELETE",
      type: ContentType.UrlEncoded,
      ...params,
    });
  /**
   * No description
   *
   * @tags accounts
   * @name PostAccount
   * @summary アカウント作成
   * @request POST:/account
   */
  postAccount = (
    data: {
      /** メールアドレス */
      email: string;
      /**
       * 招待コード
       * @default null
       */
      invite_code?: string;
      /**
       * 通知許可100円OFFクーポンを受け取るか
       * @default "0"
       */
      notification_coupon?: "0" | "1";
      /** パスワード */
      password: string;
      /**
       * 新規登録10%OFFクーポンを受け取るか
       * @default "0"
       */
      signup_coupon?: "0" | "1";
    },
    params: RequestParams = {},
  ) =>
    this.request<any, void>({
      path: `/account`,
      method: "POST",
      body: data,
      type: ContentType.UrlEncoded,
      ...params,
    });
  /**
   * No description
   *
   * @tags accounts
   * @name PutAccount
   * @summary アカウント情報の更新
   * @request PUT:/account
   */
  putAccount = (
    data: {
      /**
       * 新しいメールアドレス
       * @default null
       */
      new_email?: string;
      /**
       * 新しいパスワード
       * @default null
       */
      new_password?: string;
      /** 現在のパスワード */
      password: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, void>({
      path: `/account`,
      method: "PUT",
      body: data,
      type: ContentType.UrlEncoded,
      ...params,
    });
}
